import axiosInstance, { pannelInstance } from "./axiosinstance";
import { apiUrl, pannelApiUrl } from "../routes/apiRoutes";
import { apiEndpoint } from "./apiendpoint";

export { apiUrl };

const pannelEmail = process.env.REACT_PANNEL_EMAIL;
const pannelPassword = process.env.REACT_PANNEL_PASSWORD;

// api collection for admin

export const logoutUserAPI = async () => {
  try {
    const { data } = await axiosInstance.get(apiUrl.LOGOUT);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const createWebinarAPI = async (payload) => {
  const formData = new FormData();

  formData.append("topic", payload.topic);
  formData.append("slug", payload.slug);
  if (payload.category) formData.append("category", payload.category);
  if (payload.startDate) formData.append("startDate", payload.startDate);
  if (payload.endDate) formData.append("endDate", payload.endDate);
  if (payload.objective) formData.append("objective", payload.objective);
  if (payload.audience) formData.append("audience", payload.audience);
  if (payload.instructorName)
    formData.append("instructorName", payload.instructorName);
  if (payload.instructorTitle)
    formData.append("instructorTitle", payload.instructorTitle);
  if (payload.posterFile) formData.append("webinarposter", payload.posterFile);

  const res = await axiosInstance.post(apiUrl.POST_WEBINAR, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const getWebinarsAPI = async ({ signal }) => {
  const res = await axiosInstance.get(apiUrl.GET_WEBINARS, { signal });
  return res.data;
};

export const getWebinarRegistrationsAPI = async (webinarId) => {
  const res = await axiosInstance.get(
    `${apiUrl.GET_WEBINAR_REGISTRATIONS}/${webinarId}/registrations`,
  );
  return res.data;
};

export const getLecturesByCourseIdAPI = async (courseId) => {
  if (!courseId)
    return { status: false, message: "Course id is required", data: [] };
  const res = await axiosInstance.get(
    `${apiUrl.GET_LECTURE_BY_COURSE}/${courseId}`,
  );
  return res.data;
};

export const deleteLectureAPI = async (lectureId) => {
  if (!lectureId) return { status: false, message: "Lecture id is required" };
  const res = await axiosInstance.delete(
    `${apiUrl.DELETELECTURE}/${lectureId}`,
  );
  return res.data;
};

export const postReviewAPI = async (review) => {
  try {
    const { data } = await axiosInstance.post(apiEndpoint.reviews, review);
    return data;
  } catch (error) {
    return { status: false, message: error.message, data: [] };
  }
};

export const getAdminReviewsAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiEndpoint.adminReviews, {
      signal,
    });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

export const approveAdminReviewAPI = async (reviewId) => {
  try {
    const { data } = await axiosInstance.patch(
      apiEndpoint.adminReviewApprove(reviewId),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const rejectAdminReviewAPI = async (reviewId) => {
  try {
    const { data } = await axiosInstance.patch(
      apiEndpoint.adminReviewReject(reviewId),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const getBlogsAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_BLOGS, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

export const postBlogAPI = async (payload) => {
  try {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (key === "blog" && payload.blog instanceof File) {
        formData.append("blog", payload.blog);
      } else if (
        key !== "blog" &&
        payload[key] !== undefined &&
        payload[key] !== null
      ) {
        const val = payload[key];
        formData.append(key, Array.isArray(val) ? JSON.stringify(val) : val);
      }
    });
    const { data } = await axiosInstance.post(apiUrl.POST_BLOG, formData, {
      headers: { "Content-Type": undefined },
    });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const updateBlogAPI = async (id, payload) => {
  try {
    if (payload.blog instanceof File) {
      const formData = new FormData();
      Object.keys(payload).forEach((key) => {
        if (key === "blog") {
          formData.append("blog", payload.blog);
        } else if (payload[key] !== undefined && payload[key] !== null) {
          const val = payload[key];
          formData.append(key, Array.isArray(val) ? JSON.stringify(val) : val);
        }
      });
      const { data } = await axiosInstance.patch(
        apiUrl.UPDATE_BLOG(id),
        formData,
        {
          headers: { "Content-Type": undefined },
        },
      );
      return data;
    }
    const { data } = await axiosInstance.patch(apiUrl.UPDATE_BLOG(id), payload);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const deleteBlogAPI = async (id) => {
  try {
    const { data } = await axiosInstance.delete(apiUrl.DELETE_BLOG(id));
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Prebooking & Payment Tracking
export const getPrebookingsAPI = async (params = {}) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_PREBOOKINGS(params));
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: {
        items: [],
        pagination: { page: 1, limit: 10, total: 0, totalPages: 0 },
      },
    };
  }
};

export const assignBatchToPrebookingAPI = async (prebookingId, batch) => {
  try {
    const { data } = await axiosInstance.patch(
      apiUrl.PATCH_PREBOOKING(prebookingId),
      {
        batch,
      },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Course Content
export const getCourseContentsAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_COURSE_CONTENTS, {
      signal,
    });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

export const getCourseContentByIdAPI = async (id) => {
  try {
    const { data } = await axiosInstance.get(
      apiUrl.GET_COURSE_CONTENT_BY_ID(id),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const postCourseContentAPI = async (payload) => {
  try {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      const val = payload[key];
      if (key === "syllabusFile" && val instanceof File) {
        formData.append("coursesyllabus", val);
      } else if (key !== "syllabusFile" && val !== undefined && val !== null) {
        formData.append(
          key,
          typeof val === "object" ? JSON.stringify(val) : val,
        );
      }
    });
    const { data } = await axiosInstance.post(
      apiUrl.POST_COURSE_CONTENT,
      formData,
      { headers: { "Content-Type": undefined } },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const patchCourseContentAPI = async (id, payload) => {
  try {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      const val = payload[key];
      if (key === "syllabusFile" && val instanceof File) {
        formData.append("coursesyllabus", val);
      } else if (key !== "syllabusFile" && val !== undefined && val !== null) {
        formData.append(
          key,
          typeof val === "object" ? JSON.stringify(val) : val,
        );
      }
    });
    const { data } = await axiosInstance.patch(
      apiUrl.PATCH_COURSE_CONTENT(id),
      formData,
      { headers: { "Content-Type": undefined } },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const deleteCourseContentAPI = async (id) => {
  try {
    const { data } = await axiosInstance.delete(
      apiUrl.DELETE_COURSE_CONTENT(id),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Demo Videos
export const getDemoVideosAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_DEMO_VIDEOS, {
      signal,
    });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: { demoVideos: [] },
    };
  }
};

export const createDemoVideoAPI = async (payload) => {
  try {
    const { data } = await axiosInstance.post(apiUrl.POST_DEMO_VIDEO, payload);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const updateDemoVideoAPI = async (id, payload) => {
  try {
    const { data } = await axiosInstance.patch(
      apiUrl.UPDATE_DEMO_VIDEO(id),
      payload,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const deleteDemoVideoAPI = async (id) => {
  try {
    const { data } = await axiosInstance.delete(apiUrl.DELETE_DEMO_VIDEO(id));
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Placements
export const getPlacementsAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_PLACEMENTS, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: { placements: [] },
    };
  }
};

export const createPlacementAPI = async (payload) => {
  const formData = new FormData();
  formData.append("studentName", payload.studentName);
  formData.append("companyName", payload.companyName);
  if (payload.package) formData.append("package", payload.package);
  if (payload.profileFile)
    formData.append("placementprofile", payload.profileFile);

  const res = await axiosInstance.post(apiUrl.POST_PLACEMENT, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updatePlacementAPI = async (id, payload) => {
  const formData = new FormData();
  if (payload.studentName !== undefined)
    formData.append("studentName", payload.studentName);
  if (payload.companyName !== undefined)
    formData.append("companyName", payload.companyName);
  if (payload.package !== undefined)
    formData.append("package", payload.package);
  if (payload.isEnabled !== undefined)
    formData.append("isEnabled", payload.isEnabled);
  if (payload.profileFile)
    formData.append("placementprofile", payload.profileFile);

  const hasFile = payload.profileFile instanceof File;
  const res = hasFile
    ? await axiosInstance.patch(apiUrl.UPDATE_PLACEMENT(id), formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    : await axiosInstance.patch(apiUrl.UPDATE_PLACEMENT(id), payload);

  return res.data;
};

export const deletePlacementAPI = async (id) => {
  try {
    const { data } = await axiosInstance.delete(apiUrl.DELETE_PLACEMENT(id));
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Video Reviews
export const getVideoReviewsAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_VIDEO_REVIEWS, {
      signal,
    });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

export const createVideoReviewAPI = async (formData) => {
  try {
    const { data } = await axiosInstance.post(
      apiUrl.POST_VIDEO_REVIEW,
      formData,
      {
        headers: { "Content-Type": undefined },
      },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const approveVideoReviewAPI = async (id) => {
  try {
    const { data } = await axiosInstance.patch(
      apiUrl.PATCH_VIDEO_REVIEW_APPROVE(id),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const rejectVideoReviewAPI = async (id) => {
  try {
    const { data } = await axiosInstance.patch(
      apiUrl.PATCH_VIDEO_REVIEW_REJECT(id),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const deleteVideoReviewAPI = async (id) => {
  try {
    const { data } = await axiosInstance.delete(apiUrl.DELETE_VIDEO_REVIEW(id));
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Enquiries
export const getEnquiriesAPI = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_ENQUIRIES, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

// Jobs (admin)
export const getJobsAdminAPI = async ({ signal } = {}) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_JOBS, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: { jobs: [] },
    };
  }
};

export const createJobAPI = async (payload) => {
  try {
    const { data } = await axiosInstance.post(apiUrl.POST_JOB, payload);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const updateJobAPI = async (id, payload) => {
  try {
    const { data } = await axiosInstance.patch(apiUrl.UPDATE_JOB(id), payload);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const deleteJobAPI = async (id) => {
  try {
    const { data } = await axiosInstance.delete(apiUrl.DELETE_JOB(id));
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

/// pannel api collection

export const loginToPannelAPI = async () => {
  let payload = {
    email: process.env.REACT_APP_PANNEL_EMAIL,
    password: process.env.REACT_APP_PANNEL_PASSWORD,
  };
  console.log("pannel payload", payload);
  try {
    const { data } = await pannelInstance.post(
      pannelApiUrl.LOGIN_TO_PANNEL,
      payload,
    );
    localStorage.setItem("token", data?.token);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const getAllAdmissionsAPI = async ({
  limit = 10,
  page = 1,
  search = "",
  signal,
}) => {
  try {
    const response = await pannelInstance.get(
      pannelApiUrl.ADMISSION(limit, page, search),
      { signal },
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// Dashboard stats
export const getDashboardStatsAPI = async ({ signal }) => {
  const defaults = {
    courses: 0,
    batches: 0,
    students: 0,
    webinars: 0,
    blogs: 0,
    courseContents: 0,
    instructors: 0,
    reviews: 0,
  };
  try {
    const [
      coursesRes,
      batchesRes,
      webinarsRes,
      blogsRes,
      contentsRes,
      instructorsRes,
      reviewsRes,
    ] = await Promise.all([
      axiosInstance.get(apiUrl.GETCOURSES, { signal }),
      axiosInstance.get(apiUrl.GET_BATCHES, { signal }),
      axiosInstance.get(apiUrl.GET_WEBINARS),
      axiosInstance.get(apiUrl.GET_BLOGS, { signal }),
      axiosInstance.get(apiUrl.GET_COURSE_CONTENTS, { signal }),
      axiosInstance.get(apiUrl.GET_INSTRUCTORS, { signal }),
      axiosInstance.get(apiEndpoint.adminReviews, { signal }),
    ]);

    const getCount = (res, key) => {
      const data = res?.data?.data;
      if (Array.isArray(data)) return data.length;
      if (data?.[key] && Array.isArray(data[key])) return data[key].length;
      if (data && Array.isArray(data)) return data.length;
      return 0;
    };

    return {
      courses: getCount(coursesRes),
      batches: getCount(batchesRes),
      webinars: getCount(webinarsRes, "webinars"),
      blogs: getCount(blogsRes),
      courseContents: getCount(contentsRes),
      instructors: getCount(instructorsRes),
      reviews: getCount(reviewsRes),
    };
  } catch (error) {
    return defaults;
  }
};

export const checkSlugAvailabilityAPI = async (slug) => {
  try {
    const { data } = await axiosInstance.get(
      apiUrl.CHECK_SLUG_AVAILABILITY(slug),
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const updateWebinarAPI = async (id, payload) => {
  try {
    const response = await axiosInstance.patch(apiUrl.UPDATE_WEBINAR(id), payload);
    return response.data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};


export const getOfferApi = async ({ signal }) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_OFFER, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const createOfferApi = async (payload) => {
  try {
    const { data } = await axiosInstance.post(apiUrl.POST_OFFER, payload);
    return data;
  }
    catch (error) {    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
}

export const updateOfferApi  = async(id, payload) => {
  try {
    const { data } = await axiosInstance.patch(apiUrl.UPDATE_OFFER(id), payload);
    return data;
  }
  catch (error) {    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
}

export const deleteOfferApi  = async(id) => {
  try {
    const { data } = await axiosInstance.delete(apiUrl.DELETE_OFFER(id));
    return data;
  }
  catch (error) {    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
}


export const getHireFromUsAPI = async (payload) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_HIRE_FROM_US, payload);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};


// ================= FAQ (admin) =================
// course: "general" -> Home page FAQ,  <courseId> -> us course ke FAQ
export const getFaqsAPI = async ({ course = "general", signal } = {}) => {
  const res = await axiosInstance.get(apiUrl.GET_FAQS, {
    params: { course },
    signal,
  });
  return res.data;
};

// payload: { question, answer, course, isActive }
export const createFaqAPI = async (payload) => {
  const res = await axiosInstance.post(apiUrl.POST_FAQ, payload);
  return res.data;
};

// { course, faqs: [{ question, answer }] }
export const bulkCreateFaqsAPI = async (course, faqs) => {
  const res = await axiosInstance.post(apiUrl.BULK_FAQ, { course, faqs });
  return res.data;
};

export const updateFaqAPI = async (id, payload) => {
  const res = await axiosInstance.patch(apiUrl.UPDATE_FAQ(id), payload);
  return res.data;
};

export const deleteFaqAPI = async (id) => {
  const res = await axiosInstance.delete(apiUrl.DELETE_FAQ(id));
  return res.data;
};

export const reorderFaqsAPI = async (ids) => {
  const res = await axiosInstance.patch(apiUrl.REORDER_FAQS, { ids });
  return res.data;
};

// Chatbot queries — every question asked to the chatbot + whether it was
// answered from website data or fell back to the "please call us" CTA.
export const getChatbotQueriesAPI = async ({ signal } = {}) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_CHATBOT_QUERIES, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

// Leads captured by the chatbot (name/phone shared by visitors for a callback)
export const getChatbotLeadsAPI = async ({ signal } = {}) => {
  try {
    const { data } = await axiosInstance.get(apiUrl.GET_CHATBOT_LEADS, { signal });
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
      data: [],
    };
  }
};